import { Box, Button, Typography } from '@mui/material'
import FormModalContainer from '../../../components/Modals/FormModalContainer'
import UseTranslation from '../../../hooks/UseTranslation'
import { ReactComponent as WarningTriangleIcon } from '../../../images/WarningTriangle.svg'

const DeclineConsentFormModal = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = UseTranslation()

  return (
    <FormModalContainer
      modalState={open}
      handleClose={onClose}
      customWidth="460px"
      customModalStyle={styles.modalBody}
      borderStyle
      disappearCancelButton
      modalTitle=""
      hideCloseIcon
    >
      <Box sx={styles.modalContent}>
        <Box sx={styles.modalHeader}>
          <Box sx={styles.modalIconWrap}>
            <WarningTriangleIcon style={styles.modalIcon} />
          </Box>
          <Typography sx={styles.modalTitle}>
            {t?.['Decline consent & sign out?']}
          </Typography>
        </Box>
        <Typography sx={styles.modalText}>
          <Box component="span">
            {t?.['If you decline, you will be ']}
          </Box>
          <Box component="span" sx={styles.modalTextEmphasis}>
            {t?.['signed out immediately ']}
          </Box>
          <Box component="span">{t?.['and will not be able to use Orgarise. Without your consent, the Company cannot process your personal data through the system.']}</Box>

        </Typography>
        <Typography sx={styles.modalText}>
          {t?.['You can sign in again at any time to review and approve the consent form, or contact your HR department for help.']}
        </Typography>
      </Box>
      <Box sx={styles.modalActions}>
        <Button variant="outlined" onClick={onClose} sx={styles.cancelBtn}>
          {t?.['Go back']}
        </Button>
        <Button variant="contained" onClick={onConfirm} sx={styles.confirmBtn}>
          {t?.['Decline & sign out']}
        </Button>
      </Box>
    </FormModalContainer>
  )
}

const styles = {
  modalBody: {
    borderRadius: '16px',
    padding: '0 !important',
    minWidth: { xs: '92%', sm: '460px' },
    maxHeight: 'unset',
    overflow: 'hidden',
  },
  modalContent: {
    px: 3,
    pt: 3,
    pb: 2.5,
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    mb: 2,
  },
  modalIconWrap: {
    width: 40,
    height: 40,
    borderRadius: '999px',
    backgroundColor: '#fdeced',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  modalIcon: {
    color: '#e25555',
    fontSize: 22,
  },
  modalTitle: {
    fontSize: '1.3rem',
    lineHeight: 1.2,
    fontWeight: 700,
    color: '#1f2937',
  },
  modalText: {
    fontSize: '0.75rem',
    color: '#4b5563',
    lineHeight: 1.65,
    '& + &': {
      mt: 1.25,
    },
  },
  modalTextEmphasis: {
    fontWeight: 700,
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 1.25,
    px: 3,
    py: 2,
    borderTop: '1px solid #ebecef',
  },
  cancelBtn: {
    minHeight: 42,
    minWidth: 96,
    borderRadius: '12px',
    textTransform: 'none',
    borderColor: '#d1d5db',
    color: '#4b5563',
  },
  confirmBtn: {
    minHeight: 42,
    minWidth: 148,
    borderRadius: '12px',
    textTransform: 'none',
    backgroundColor: '#e25555',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#cf4a4a',
    },
  },
}

export default DeclineConsentFormModal
